import { MDTApp } from 'mdt-core-components/src/actions/bootAction';
import { MDTApi } from 'mdt-core-components/src/services/mdtapi';
import { findIndex, isArray } from 'lodash';

async function checkPriceResponse(
    checkPriceItem,
    t,
    prodList = [],
    showLoader = true,
    url = 'api.quickOrder.checkPriceAndAvailability'
) {
    let result = [];
    await MDTApi.call(
        url,
        {
            method: 'POST',
            data: checkPriceItem,
            successCallback: (response) => {
                result = handleCheckPriceResponse(t, prodList, response);
            },
            errorCallBack: (error) => {
                if (error && error.config && error.config.error)
                    error.config.error(error.response, MDTApp.showNotification);
                throw error.response;
            },
        },
        '',
        showLoader
    );

    return result;
}

function handleCheckPriceResponse(t, prodList, data) {
    const lineItem = [...prodList];
    const priceAndAvailability = data.priceAndAvailability || [];
    const checkPriceList = [];
    priceAndAvailability.map((obj) => {
        const i = getStoreProductIndex(lineItem, obj.productCFN, obj.lineItemID);
        const proObj = lineItem && lineItem.length > 0 ? Object.assign({}, lineItem[i]) : [];
        let price = '';
        let displayBasePrice = '';
        let priceAvai = false;
        let zeroPriceValid = false;

        if (typeof obj.displayFacingPrice !== 'undefined') {
            if (!obj.isPriceApplicable) {
                price = t('error.priceNotAvailable');
            } else {
                price = obj.displayFacingPrice;
                if (!!obj.displayBasePrice) {
                    displayBasePrice = obj.displayBasePrice;
                }
                zeroPriceValid = obj.zeroPriceValid && obj.zeroPriceValid;
                priceAvai = true;
            }
        }
        if (lineItem && lineItem.length > 0) {
            proObj.product.availability = obj.productAvailability || '';
            proObj.product.price = price;
            proObj.product.displayBasePrice = displayBasePrice;
            proObj.product.isoCode = obj.currency.isocode;
            proObj.product.priceAvai = priceAvai;
            proObj.product.productAvailability = obj.productAvailability || '';
            ((proObj.product.custNoteCode = obj.custNoteCode || ''),
                (proObj.product.zeroPriceValid = zeroPriceValid));
            proObj.product.productNextShipDate = obj.productNextShipDate;
            proObj.product.productRecoveryDate = obj.productRecoveryDate;
            proObj.product.displayTotalPrice = obj.displayTotalPrice;
            proObj.product.displayBasePriceWithZMDO = obj.displayBasePriceWithZMDO;
            checkPriceList.push(proObj);
        } else {
            const prodObj = {
                availability: obj.productAvailability || '',
                price: price,
                isoCode: (obj.currency && obj.currency.isocode) || '',
                displayBasePrice: displayBasePrice,
                priceAvai: priceAvai,
                productAvailability: obj.productAvailability || '',
                custNoteCode: obj.custNoteCode || '',
                zeroPriceValid: zeroPriceValid,
                productNextShipDate: obj.productNextShipDate,
                productRecoveryDate: obj.productRecoveryDate,
                displayTotalPrice: obj.displayTotalPrice,
                displayBasePriceWithZMDO: obj.displayBasePriceWithZMDO,
            };
            checkPriceList.push(prodObj);
        }
    });

    if (
        typeof data.priceAndAvailability === 'undefined' ||
        (isArray(data.priceAndAvailability) && data.priceAndAvailability.length === 0)
    ) {
        const prodObj = {
            availability: '',
            price: t('error.priceNotAvailable'),
            isoCode: '',
            displayBasePrice: '',
            priceAvai: false,
            productAvailability: '',
            custNoteCode: '',
        };
        checkPriceList.push(prodObj);
    }

    return checkPriceList;
}
const getStoreProductIndex = (arr, pCfn, index) => {
    findIndex(
        arr,
        (v, i) => v.show && v.product.vendorPartNumber === pCfn && i === parseInt(index)
    );
};
const CheckPriceUtility = {
    checkPriceResponse,
};

export default CheckPriceUtility;
